import {t} from '@lingui/core/macro';

import {IColumn} from 'shared/ui/Table/Table';
import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';

export function getHttpIncidentColumns(hideMonitor: boolean): IColumn[] {
    const cols: IColumn[] = [
        {label: t`Статус`, sort: 'resolved'},
        {label: t`Монитор`, sort: 'monitor.url'},
        {label: t`Проблемы в локациях`},
        {label: t`Начало`, sort: 'created_at'},
        {label: t`Решен`, sort: 'resolved_at'},
        {label: t`Длительность`},
        {label: ''},
    ];

    return hideMonitor ? cols.filter(col => col.label !== t`Монитор`) : cols;
}

export function getHttpIncidentTooltip(item: IHttpIncident): string {
    if (!item.resolved && item.incomplete_fail) {
        return t`Инцидент создан при неполных данных`;
    }
    if (item.resolved && item.incomplete_success) {
        return t`Инцидент закрыт при неполных данных`;
    }
    if (!item.resolved && !item.incomplete_fail) {
        return t`Инцидент не решен`;
    }
    if (item.resolved && !item.incomplete_success) {
        return t`Инцидент решен`;
    }
    return '';
}

export function isHttpMonitorDetailsPath(pathname: string): boolean {
    return pathname.includes('/monitors/') && pathname.includes('/details');
}

export function getHttpIncidentLocationsCounts(item: IHttpIncident): {count: number, total: number} {
    const isOldIncidentWithoutGeo = item.fail_locations_count === 0;

    return {
        count: isOldIncidentWithoutGeo ? 1 : item.fail_locations_count,
        total: isOldIncidentWithoutGeo ? 1 : item.total_locations_count,
    };
}
